import _ from 'lodash'
import $ from 'jquery'
import { i18n } from './i18n'
import './lib/jquery.soap'
import X2JS from 'x2js'
import { getUrl, packageData } from './bizTypeMapping.js'
import { routerule, wareHouseInfo, $notify } from '@/global'
import Cookies from 'js-cookie'
import { customizeNotifyWithVoiceFormat as customizeNotifyWithVoice, NOTIFY_TYPE_ENUM } from '@/api/utils/message.js'
import addStreamLog from '@/api/lib/stream'
import SgmMonitor from '@/api/lib/monitor'
import { newGuid } from '@/api/utils/guid'
import { pushPrintPoint } from '@/utils/setMethods'
import { addLog } from '../api/lib/addLog.js';
// import {tracker} from '../utils/tracker/index.js'
// import { paramsTrim } from './utils/tool'

let getRouterule = () => {
  return routerule.value
}

let getWareHouseInfo = () => {
  return wareHouseInfo
}

// let canShowError = true

// config.withoutWarehouse:true -- 不添加仓库信息
// config.noParseJson:true -- 不按json方式处理结果
export const soapPost = (bizType, para, config) => {
  const bizName=JSON.parse(bizType.arg0).bizType;
  const requestId=newGuid()

  const trackQuery={
    id: window.trackId ||'',
    bizName,
    status: 'click',
    requestId
  }
  try {
    if (!(config && config.withoutWarehouse) && _.isObject(para)) {
      Object.assign(para, getWareHouseInfo())
    }
    let noParseJson = false
    if (config && config.noParseJson) {
      noParseJson = true
    }
    let noShowError = false
    if (config && config.noShowError) {
      noShowError = true
    }

    // 回调，由使用者传递
    let callback = config && config.callback
    // 参数统一trim
    // para = paramsTrim(para)
    var requestData = JSON.stringify(para)
    // 没有data字段，soap认为是在配置 TODO: 不要配置，直接调用
    $.soap({
      url: getUrl(bizType),
      namespaceQualifier: 'wms3',
      namespaceURL: 'http://wms3.360buy.com',
      appendMethodToURL: false,
      timeout: -1,
      error: function (soapResponse) {
        // eslint-disable-next-line no-undef
        mainVm.$store.commit('resetStop')
        console.log('soap call failed!')
      }
    })
    let routerule = getRouterule()
    let token = Cookies.get('lwms.sec.token')
    let userName = Cookies.get('userName')
    const warehouseNo = Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo')
    if (warehouseNo && userName) {
      localStorage.setItem(`lastInvokeTime_${warehouseNo}_${userName}`, Date.now())
    }
    let x2js = new X2JS()
    let timeBegin = new Date().getTime()
    // window.trackId && tracker(window.trackKey, trackQuery)
    return $.soap({
      method: 'queryWs',
      data: packageData(bizType, requestData),
      withCredentials: true,
      SOAPAction: '',
      context: this, // bound to current scope
      HTTPHeaders: {
        'routerule': routerule,
        'Authorization': token,
        'userName': encodeURIComponent(userName)
      },
      // 钩子定义在jquerysoap.js
      success: function (soapResponse) {
        //console.log("soap call success!");
      },
      error: function (soapResponse) {
        let timeEnd = new Date().getTime()
        console.log("soap call error!")
        // eslint-disable-next-line no-undef
        mainVm.$store.commit('resetStop')

        if (soapResponse.status === 'timeout') {
          addStreamLog({
            code: soapResponse.httpCode,
            url: getUrl(bizType),
            requestParams: packageData(bizType, requestData),
            msg: soapResponse.httpText + soapResponse.status,
            timeBegin: timeBegin,
            timeEnd: timeEnd,
          })
          $notify.error('timeout!', config)
        } else if (soapResponse.httpCode === 401) {
          // window.mainVm.$store.commit('LOGIN_MODEL', true)
          $notify.error(i18n.t('302errorInfo'), config)
        } 
        // else if (soapResponse.httpCode === 302) {
        //   $notify.error(soapResponse.status + ':' + i18n.t('302errorInfo'), config)
        // } 
        else {
          addStreamLog({
            code: soapResponse.httpCode,
            url: getUrl(bizType),
            requestParams: packageData(bizType, requestData),
            msg: soapResponse.httpText + soapResponse.status,
            timeBegin: timeBegin,
            timeEnd: timeEnd,
          })
          let httpRes = {
            httpCode: soapResponse.httpCode,
            text: ''
          };
          try {
            let bizTypeArg0 = JSON.parse(bizType.arg0);
            let url = bizType?.uri.split('/')[1];
            httpRes.text = `${url} ${bizTypeArg0?.bizType}`;
          } catch (e) {

          }
          // 上报埋点
          try {
            addLog('requestFailed', '请求失败', {
              soapResponse: {
                content: soapResponse?.content,
                headers: soapResponse?.headers,
                httpCode: soapResponse?.httpCode,
                httpText: soapResponse?.httpText,
                status: soapResponse?.status,
                typeOf: soapResponse?.typeOf,
              },
              bizType: bizType, 
              cookie: document.cookie
            });
          } catch (e) {
            console.error('requestFailed err', e);
          }
          $notify.error(`${i18n.t('requestFailed')}: ${httpRes.httpCode} ${httpRes.text}`, config);
          // $notify.error(soapResponse.status + ':' + soapResponse.httpText, config)
          // if (soapResponse.httpText === 'error') {
          //   if (canShowError) {
          //     canShowError = false
          //     $notify.error(i18n.t('httpRequestError'), config)
          //     setTimeout(() => {
          //       canShowError = true
          //     }, 1000);
          //   }
          // } else {
          //   $notify.error(soapResponse.status + ':' + soapResponse.httpText, config)
          // }
        }
      }
    }).then(function (data, textStatus, jqXHR) {
      let timeEnd = new Date().getTime()
      pushPrintPoint(bizName,timeEnd-timeBegin,timeBegin)
      var domNode = data.firstElementChild.lastElementChild.lastElementChild.firstElementChild
      var result = x2js.dom2js(domNode)
      // console.log('ajaxSoap.bizType='   + JSON.stringify(bizType) + ", ajaxSoap.data=" + requestData + ", ajaxSoap.result=" + JSON.stringify(result));
      try {
        SgmMonitor.customMonitor({
          code: 'SGM_custom_common_request',
          msg: {
            desc: 'iwms-request-common-request',
            params: {
              code: result.resultCode,
              url: getUrl(bizType),
              requestParams: packageData(bizType, requestData)
            }
          }
        })
        SgmMonitor.customMonitor({
          code: 'SGM_custom_common_response',
          msg: {
            desc: 'iwms-request-common-response',
            params: {
              code: result.resultCode,
              url: getUrl(bizType)
              // response: result
            }
          }
        })

      } catch (error) {
        console.log('SGMcustom common request error', error)
      }
      if (callback) {
        trackQuery.status='success'
        trackQuery.resultCode= result.resultCode
        // window.trackId && tracker(window.trackKey, trackQuery)
        return callback(result)
      }
      if (result.resultCode === '1') {
        trackQuery.status='success'
        trackQuery.resultCode= result.resultCode
        // window.trackId && tracker(window.trackKey, trackQuery)
        if (noParseJson) {
          return result.resultValue
        }
        return result.resultValue === undefined ? undefined : JSON.parse(result.resultValue)
      }
      if (result.resultCode === '2') {
        trackQuery.status='success'
        trackQuery.resultCode= result.resultCode
        // window.trackId && tracker(window.trackKey, trackQuery)
        // ShipmentGlobalMessageCode.java 定义了专门返回空的情况 那批Java C#程序员不会用isEmpty
        // 我们限制不了人家解决问题的想象力(智障)
        return null
      }
      trackQuery.status='failed'
      trackQuery.resultCode= result.resultCode
      // window.trackId && tracker(window.trackKey, trackQuery)
      // resultCode 将按errorCode 处理
      var formatData = []
      var message = ''
      if (!config) {
        config = {}
      }
      if (_.isString(config.formatData) || _.isNumber(config.formatData)) {
        formatData = [config.formatData]
      }
      if (_.isObjectLike(config.formatData)) {
        formatData = config.formatData
      }
      if (_.isEmpty(formatData) && !_.isEmpty(result.resultValue)) {
        if (noParseJson) {
          formatData = [result.resultValue]
        } else {
          try {
            formatData = JSON.parse(result.resultValue)
          } catch (e) {
            formatData = [result.resultValue]
            console.error('exception occurred when parsing json string', e)
          }
        }
        try {
          if (config.translate && formatData) {
            for (let i = 0; i < formatData?.length; i++) {
              formatData[i] = i18n.t(formatData[i]);
            }
          }
        } catch (e) {
          console.error('ajaxSoap translate error', e, formatData);
        }
        
      }
      message = i18n.t(result.resultCode, formatData)
      if (message === result.resultCode && !_.isEmpty(result.resultMessage)) {
        message = result.resultMessage
      }
      // console.log(result.resultCode + ':' + message)
      // eslint-disable-next-line no-undef
      mainVm.$store.commit('resetStop')
      addStreamLog({
        code: result.resultCode,
        url: getUrl(bizType),
        requestParams: packageData(bizType, requestData),
        msg: message,
        timeBegin: timeBegin,
        timeEnd: new Date().getTime()
      })

      try {
        SgmMonitor.customMonitor({
          code: 'SGM_custom_common',
          msg: {
            desc: 'iwms-request-common',
            error: message,
            params: {
              code: result.resultCode,
              url: getUrl(bizType),
              requestParams: packageData(bizType, requestData),
            }
          }
        })
      } catch (error) {
        console.log('SGMcustom common request error', error)
      }

      // $notify.error 会默认抛异常阻止当前页面线程。内容页面如果定义 blockException:true ,则该页面不受此规则影响
      if (!noShowError) {
        // 自定义格式提示
        customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, message, config)
        // $notify.error(message, config)
      }
      return result
    })
  } catch (error) {
    console.log("soapPost error:" + error)
  }
}
